import { httpPost } from 'src/utils/http';

const getPath = (path: string) => `/Logger/${path}`;

export const apiLoggerAddLog = (message: string): Promise<string> => httpPost(getPath('AddLog'), { message });
